/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {JSONable} from '@irian-ro/abstract-resource';

export class HandoverContactDTO extends JSONable {

  uuid: string | null = null;

  name: string | null = null;

  email: string | null = null;

  phoneNumber: string | null = null;
}
